import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import SuccessAlert from "../child/Alert/SuccessAlert";
import DengerAlert from "../child/Alert/DengerAlert";
import Loader from "../child/Loder";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchUserById,
  addAdminNotes,
} from "../../redux/user/userThunks";
import { clearUserData } from "../../redux/user/userSlice";
import moment from "moment";
import UserReportsListPage from "./UserReportsListPage";
import UserActivityListPage from "./UserActivityListPage";
import { getModulePermissions } from "../../utils/permissionUtils";
import { openAddCoinsModal } from "./adminCoinModal";
import UserBlockedListPage from "./UserBlockedListPage";
import { deleteUserPhotoAPI } from "../services/userService";
import Swal from "sweetalert2";
import IntroPausePanel from "./IntroPausePanel";
import LiveHostPanel from "./LiveHostPanel";
import NameReviewPanel from "./NameReviewPanel";
import { faceCheckSummary } from "./faceCheckLabel";
import { handleUnauthorized } from "../../utils/apiHelper";



const ViewUserPageNew = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();

  const { userData, setUserData, loading, error, activityLogs, loadingActivity } = useSelector(
    (state) => state.user
  );
  const { shouldCheckPermissions, canEdit, canAdd, canView, canDelete } =
    getModulePermissions("User");

  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [activeTab, setActiveTab] = useState("view-user");
  const [note, setAdminNote] = useState("");
  const [errors, setErrors] = useState({});
  const [openDetails, setOpenDetails] = useState("")
  const [currentPage, setCurrentPage] = useState(1);
  const [userCoins, setUserCoins] = useState("")
  // What the last pause or resume did (which introductions closed, the next
  // line). Held here, not in the panel: the refresh below swaps the page for
  // the loader, which would unmount the panel and drop it.
  const [pauseResult, setPauseResult] = useState(null);
  // Same for the Live host role (2026-10-12).
  const [hostResult, setHostResult] = useState(null);
  // Same for "Name needs a look" (2026-10-15).
  const [nameResult, setNameResult] = useState(null);



  useEffect(() => {
    setPauseResult(null);
    setNameResult(null);
    dispatch(fetchUserById({ id, navigate }));

    return () => {
      dispatch(clearUserData());
    };
  }, [id, navigate, dispatch]);

  // Pause or resume landed: keep what it did, and reload the member so the
  // line, the button and the admin notes the server appended are current.
  const handlePauseChanged = (result) => {
    setPauseResult(result);
    dispatch(fetchUserById({ id, navigate }));
  };
  const handleHostChanged = (result) => {
    setHostResult(result);
    setPauseResult(null);
    dispatch(fetchUserById({ id, navigate }));
  };
  const handleNameChanged = (result) => {
    setNameResult(result);
    dispatch(fetchUserById({ id, navigate }));
  };

  useEffect(() => {
    if (userData?.adminNotes) {
      setAdminNote(userData.adminNotes);
    }
    if (userData?.coins !== undefined) setUserCoins(userData.coins);

  }, [userData]);


  const validateNote = (value) => {
    const trimmed = value.trim();
    if (!trimmed) return "Note is required";
    return "";
  };

  const handleChange = (e) => {
    const { value } = e.target;
    setAdminNote(value);
    if (errors.note) {
      setErrors((prev) => ({ ...prev, note: "" }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationError = validateNote(note);
    if (validationError) {
      setErrors({ note: validationError });
      return;
    }

    const resultAction = await dispatch(addAdminNotes({ id, note, navigate }));

    if (addAdminNotes.fulfilled.match(resultAction)) {
      setSuccessMessage("Note added successfully");
      setTimeout(() => {
        setSuccessMessage("");
        navigate("/user");
      }, 500);
    } else {
      setErrorMessage("Failed to add note");
      setTimeout(() => setErrorMessage(""), 3000);
    }
  };

  const getLastSeenText = () => {
    if (!userData?.lastSeen) return "N/A";

    const lastSeen = moment(userData.lastSeen);
    const diffMinutes = moment().diff(lastSeen, "minutes");

    if (diffMinutes < 2) {
      return "🟢 Online";
    }

    if (diffMinutes < 60) {
      return `Last seen ${lastSeen.fromNow()}`; // e.g., "Last seen 12 minutes ago"
    }

    return `Last seen on ${lastSeen.format("DD-MM-YYYY, hh:mm A")}`;
  };



  const handleDeletePhoto = async (photoUrl) => {
    try {
      // Ask for reason
      const { value: reason, isConfirmed } = await Swal.fire({
        title: "Delete Photo",
        input: "text",
        inputLabel: "Reason for deleting this photo",
        inputPlaceholder: "Enter reason...",
        showCancelButton: true,
        confirmButtonText: "Delete",
        cancelButtonText: "Cancel",
        inputValidator: (value) => {
          if (!value) return "Reason is required!";
        },
      });

      if (!isConfirmed) return;

      // Call API
      const DeleteResponse = await deleteUserPhotoAPI(userData._id, { photoUrl, reason });
      console.log(DeleteResponse, 'DeleteResponse')

      // Update UI
      dispatch(
        fetchUserById({ id: userData._id, navigate }) // Refetch user data
      );

      Swal.fire("Deleted!", "Photo deleted successfully.", "success");
    } catch (err) {
      console.error(err);
      Swal.fire("Error!", "Failed to delete photo.", "error");
    }
  };

  if (loading) return <Loader />;

  return (
    <div className="row gy-4">
      <div className="col-md-12">
        <div className="card h-100">
          <div className="card-body p-24">
            {/* Tab Navigation */}
            {successMessage && (
              <SuccessAlert
                message={successMessage}
                onClose={() => setSuccessMessage("")}
              />
            )}
            {errorMessage && (
              <DengerAlert
                message={errorMessage}
                onClose={() => setErrorMessage("")}
              />
            )}
            <ul
              className="nav border-gradient-tab nav-pills mb-20 d-inline-flex"
              id="user-view-tab"
              role="tablist"
            >
              <li className="nav-item" role="presentation">
                <button
                  className={`nav-link d-flex align-items-center px-24 ${activeTab === "view-user" ? "active" : ""
                    }`}
                  id="tab-view-user"
                  type="button"
                  role="tab"
                  onClick={() => setActiveTab("view-user")}
                >
                  User Profile
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className={`nav-link d-flex align-items-center px-24 ${activeTab === "media" ? "active" : ""
                    }`}
                  id="tab-media"
                  type="button"
                  role="tab"
                  onClick={() => setActiveTab("media")}
                >
                  Media
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className={`nav-link d-flex align-items-center px-24 ${activeTab === "answers" ? "active" : ""
                    }`}
                  id="tab-answers"
                  type="button"
                  role="tab"
                  onClick={() => setActiveTab("answers")}
                >
                  Answers & Interests
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className={`nav-link d-flex align-items-center px-24 ${activeTab === "useractivitylog" ? "active" : ""
                    }`}
                  id="tab-useractivitylog"
                  type="button"
                  role="tab"
                  onClick={() => setActiveTab("useractivitylog")}
                >
                  User Activity Log
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className={`nav-link d-flex align-items-center px-24 ${activeTab === "blockeduser" ? "active" : ""
                    }`}
                  id="tab-blockeduser"
                  type="button"
                  role="tab"
                  onClick={() => setActiveTab("blockeduser")}
                >
                  Blocked Users
                </button>
              </li>
            </ul>

            {/* Tab Content */}
            <div className="tab-content" id="user-tab-content">
              <div
                className={`tab-pane fade ${activeTab === "view-user" ? "show active" : ""
                  }`}
                id="tab-content-view-user"
                role="tabpanel"
              >
                <div className="row">
                  <div className="col-md-3 mb-3">
                    <label className="form-label fw-bold me-2 mb-0">
                      Name:
                    </label>
                    {userData?.fullName || "N/A"}
                  </div>

                  <div className="col-md-3 mb-3">
                    <label className="form-label fw-bold me-2 mb-0">
                      Email:
                    </label>
                    {userData?.email || "N/A"}
                  </div>

                  <div className="col-md-3 mb-3">
                    <label className="form-label fw-bold me-2 mb-0">Age:</label>
                    {userData?.age ?? "N/A"}
                  </div>

                  <div className="col-md-3 mb-3">
                    <label className="form-label fw-bold me-2 mb-0">
                      Height:
                    </label>
                    {userData?.height ?? "N/A"}
                  </div>

                  <div className="col-md-3 mb-3">
                    <label className="form-label fw-bold me-2 mb-0">
                      Gender:
                    </label>
                    {userData?.gender || "N/A"}
                  </div>

                  <div className="col-md-3 mb-3">
                    <label className="form-label fw-bold me-2 mb-0">
                      Interested In:
                    </label>
                    {userData?.interestedIn || "N/A"}
                  </div>

                  {/* "Looking for" (relationshipIntent) is a dedicated field
                      like gender, not one of the dynamicAnswers, so the
                      Interests & Preferences list below never carries it —
                      it was invisible to admin until 2026-08-26. */}
                  <div className="col-md-3 mb-3">
                    <label className="form-label fw-bold me-2 mb-0">
                      Looking for:
                    </label>
                    {userData?.relationshipIntent || "N/A"}
                  </div>

                  {/* <div className="col-md-3 mb-3">
                    <label className="form-label fw-bold me-2 mb-0">
                      Orientation:
                    </label>
                    {userData?.sexualOrientation || "N/A"}
                  </div> */}

                  <div className="col-md-3 mb-3">
                    <label className="form-label fw-bold me-2 mb-0">
                      Status:
                    </label>
                    {userData?.status || "N/A"}
                  </div>

                  <div className="col-md-3 mb-3">
                    <label className="form-label fw-bold me-2 mb-0">
                      Boost:
                    </label>
                    {userData?.isBoosted ? "Yes" : "No"}
                  </div>
                  <div className="col-md-3 mb-3">
                    <label className="form-label fw-bold me-2 mb-0">
                      isFaceVerified:
                    </label>
                    {userData?.isFaceVerified ? "Yes" : "No"}
                  </div>

                  <div className="col-md-3 mb-3">
                    <label className="form-label fw-bold me-2 mb-0">
                      Availabale Coins:
                    </label>
                    {userData?.coins}
                  </div>
                  <div className="col-md-3 mb-3">
                    <label className="form-label fw-bold me-2 mb-0">
                      Active Subscription:
                    </label>
                    {userData?.activeSubscription?"Yes":"No"}
                  </div>

                  <div className="col-md-3 mb-3">
                    <label className="form-label fw-bold me-2 mb-0">
                      Profile Steps:
                    </label>
                    {/* {userData?.profileSteps?.length ?? 0} */}
                    {userData?.profileSteps?.length ?? 0} completed step
                    {userData?.profileSteps === 1 ? "" : "s"}
                  </div>

                  <div className="col-md-3 mb-3">
                    <label className="form-label fw-bold me-2 mb-0">
                      Gatekeeper Answers:
                    </label>
                    {userData?.gatekeeperAnsweredCount || 0}/3
                  </div>

                  {/* Two different questions. Last active is the heartbeat
                      stamped on any authenticated request; last login is the
                      newest `login` row in the activity log. Before the
                      2026-08-07 heartbeat these were the same field, so this
                      row could only ever show a sign-in date. */}
                  <div className="col-md-3 mb-3">
                    <label className="form-label fw-bold me-2 mb-0">
                      Last active :
                    </label>
                    {getLastSeenText()}
                  </div>

                  <div className="col-md-3 mb-3">
                    <label className="form-label fw-bold me-2 mb-0">
                      Last login :
                    </label>
                    {userData?.lastLoginAt
                      ? moment(userData.lastLoginAt).format("DD-MM-YYYY, hh:mm A")
                      : "N/A"}
                  </div>

                  <div className="col-md-3 mb-3">
                    <label className="form-label fw-bold me-2 mb-0">
                      Login Type:
                    </label>
                    {userData?.loginType || "N/A"}
                  </div>

                  <div className="col-md-3 mb-3">
                    <label className="form-label fw-bold me-2 mb-0">
                      Email Verified:
                    </label>
                    {userData?.isEmailVerified ? "Yes" : "No"}
                  </div>

                  <div className="col-md-3 mb-3">
                    <label className="form-label fw-bold me-2 mb-0">
                      Signup Date :
                    </label>
                    {moment(userData?.createdAt).format("DD-MM-YYYY")}
                  </div>

                  <div className="col-md-3 mb-3">
                    <label className="form-label fw-bold me-2 mb-0">
                      Location:
                    </label>
                    {userData?.location?.address || "N/A"}
                  </div>

                  <div className="col-md-3 mb-3">
                    <label className="form-label fw-bold me-2 mb-0">
                      Phone Number:
                    </label>
                    {userData?.phone || "N/A"}
                  </div>

                  {/* The app-facing bio is the generated one (aiBio) —
                      that is what members see as About Me. The typed
                      aboutMyself field only exists on early accounts
                      (onboarding stopped collecting it), so it renders
                      as its own row only when present. */}
                  <div className="col-md-3 mb-3">
                    <label className="form-label fw-bold me-2 mb-0">
                      Bio (AI):
                    </label>
                    {userData?.aiBio || "Not generated yet"}
                  </div>
                  {userData?.aboutMyself ? (
                    <div className="col-md-3 mb-3">
                      <label className="form-label fw-bold me-2 mb-0">
                        Bio (user-written):
                      </label>
                      {userData.aboutMyself}
                    </div>
                  ) : null}
                  <div className="col-md-3 mb-3">
                    <label className="form-label fw-bold me-2 mb-1">
                      Profile Hidden From:
                    </label>

                    {userData?.hiddenContactList?.length > 0 ? (
                      <div className="d-flex flex-wrap gap-1">
                        {userData.hiddenContactList.map((contact, index) => (
                          <span key={index} className="badge bg-secondary">
                            {contact}
                          </span>
                        ))}
                      </div>
                    ) : (
                      <span className="text-muted">N/A</span>
                    )}
                  </div>
                </div>
                {/* Pause introductions (founder go 2026-09-27): support
                    pauses a member only on their own written request. */}
                {userData?._id ? (
                  <div className="row">
                    <IntroPausePanel
                      user={userData}
                      canEdit={!shouldCheckPermissions || canEdit}
                      result={pauseResult}
                      onChanged={handlePauseChanged}
                      onDismissResult={() => setPauseResult(null)}
                      onUnauthorized={() => handleUnauthorized(navigate)}
                    />
                  </div>
                ) : null}
                {/* Name needs a look (2.6, founder 2026-10-15): a new sign-up
                    who kept a name the name check doubted. Renders nothing for
                    anyone else, existing members included. */}
                {userData?._id ? (
                  <div className="row">
                    <NameReviewPanel
                      user={userData}
                      canEdit={!shouldCheckPermissions || canEdit}
                      result={nameResult}
                      onChanged={handleNameChanged}
                      onDismissResult={() => setNameResult(null)}
                      onUnauthorized={() => handleUnauthorized(navigate)}
                    />
                  </div>
                ) : null}
                {/* Curiouzz Live host role (founder go 2026-10-12): the person
                    hired to host a room is staff, never introduced. */}
                {userData?._id ? (
                  <div className="row">
                    <LiveHostPanel
                      user={userData}
                      canEdit={!shouldCheckPermissions || canEdit}
                      result={hostResult}
                      onChanged={handleHostChanged}
                      onDismissResult={() => setHostResult(null)}
                      onUnauthorized={() => handleUnauthorized(navigate)}
                    />
                  </div>
                ) : null}
                {!shouldCheckPermissions || canEdit ? (
                  <div className="row">
                    <div className="col-md-3 mb-3">
                      <button
                        className="btn btn-primary"
                        onClick={() =>
                          openAddCoinsModal(id, dispatch, navigate, (newBalance) => setUserCoins(newBalance))
                        }
                      >
                        Add Coins
                      </button>
                    </div>
                  </div>
                ) : null}
                {/* Admin Note Form */}
                <div className="row">
                  <form onSubmit={handleSubmit} className="row gy-3">
                    <div className="col-md-12">
                      <label className="form-label">Admin Note</label>
                      <textarea
                        name="adminnote"
                        className="form-control"
                        placeholder="Enter Note"
                        value={note}
                        onChange={handleChange}
                        onInput={(e) => {
                          e.target.value = e.target.value
                            .replace(/\s{2,}/g, " ")
                            .trimStart();
                        }}
                      />
                      {errors.note && (
                        <div className="text-danger mt-1">{errors.note}</div>
                      )}
                    </div>
                    <div className="col-12 text-end">
                      <button className="btn btn-primary" type="submit">
                        Save Changes
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>

            <div className="tab-content" id="media-tab-content">
              <div
                className={`tab-pane fade ${activeTab === "media" ? "show active" : ""
                  }`}
                id="tab-content-media"
                role="tabpanel"
              >
                {activeTab === "media" && (
                  <div className="card">
                    <div className="card-body">
                      <label className="form-label fw-bold me-2 mb-10">
                        User Photos
                      </label>
                      <div className="row">
                        {userData.userPhotos?.map((photo, index) => (
                          <div key={index} className="col-md-3 mb-3">
                            <a href={photo} target="_blank" rel="noopener noreferrer">
                              <img
                                src={photo}
                                className="img-fluid rounded border"
                                alt="user"
                                style={{ width: "150px", height: "150px", objectFit: "cover" }}
                              />
                            </a>
                            {/* Delete Button */}
                            <button
                              className="btn btn-sm btn-danger  top-0 end-0 m-1"
                              onClick={() => handleDeletePhoto(photo)}
                              title="Delete photo"
                              style={{ zIndex: 10 }}
                            >
                              ✕
                            </button>
                          </div>
                        ))}
                      </div>

                      <label className="form-label fw-bold me-2 mb-10">
                        Face Verification
                      </label>
                      {userData.isFaceVerified ? (
                        <span className="badge bg-success">Verified</span>
                      ) : (
                        <span className="badge bg-danger">Not Verified</span>
                      )}

                      {/* The last face check, and which part failed (2026-10-14). */}
                      {(() => {
                        const s = faceCheckSummary(userData.faceCheckLast);
                        if (!s) return null;
                        return (
                          <div className="mt-2 small" data-testid="face-check-last">
                            <div>
                              Last face check
                              {userData.faceCheckLast.at
                                ? `, ${moment(userData.faceCheckLast.at).format("DD-MM-YYYY, hh:mm A")}`
                                : ""}
                              : {s.title}
                            </div>
                            {s.detail && <div className="text-muted">{s.detail}</div>}
                          </div>
                        );
                      })()}

                      {userData.selfieUrl && (
                        <div className="mt-3">
                          <a href={userData.selfieUrl} target="_blank" rel="noopener noreferrer">

                            <img
                              src={userData.selfieUrl}
                              alt="selfie"
                              className="img-thumbnail"

                              style={{ width: "150px", height: "150px", objectFit: "cover" }}

                            />
                          </a>
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>

            <div className="tab-content" id="answers-tab-content">
              <div
                className={`tab-pane fade ${activeTab === "answers" ? "show active" : ""
                  }`}
                id="tab-content-answers"
                role="tabpanel"
              >
                {activeTab === "answers" && (
                  <div className="card">
                    <div className="card-body">
                      <label className="form-label fw-bold me-2 mb-10">Gatekeeper Questions</label>


                      {userData.discovery_question?.length > 0 ? (
                        userData.discovery_question.map((q, i) => (
                          <div key={i} className="mb-3">
                            <strong>Q.{q.question}</strong>
                            <p className="text-muted">Answer.{q.answer}</p>
                          </div>
                        ))
                      ) : (
                        <p className="text-muted mb-3">No Gatekeeper Questions available.</p>
                      )}

                      <label className="form-label fw-bold me-2 mb-10">Interests & Preferences</label>
                      <div className="d-flex flex-wrap gap-2">
                        {userData.tags?.length > 0 ? (
                          <div className="d-flex flex-wrap gap-2">
                            {userData.tags.map((tag, i) => (
                              <span key={i} className="badge bg-light text-dark border">
                                {tag}
                              </span>
                            ))}
                          </div>
                        ) : (
                          <p className="text-muted">No interests available.</p>
                        )}
                      </div>

                    </div>
                  </div>
                )}
              </div>
            </div>

            <div className="tab-content" id="tab-useractivitylog">
              <div
                className={`tab-pane fade ${activeTab === "useractivitylog" ? "show active" : ""
                  }`}
                id="tab-content-useractivitylog"
                role="tabpanel"
              >

                <UserActivityListPage userId={id} />
              </div>
            </div>
            <div className="tab-content" id="tab-blockeduser">
              <div
                className={`tab-pane fade ${activeTab === "blockeduser" ? "show active" : ""
                  }`}
                id="tab-content-blockeduser"
                role="tabpanel"
              >

                <UserBlockedListPage userId={id} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div >
  );
};

export default ViewUserPageNew;
